define('drops/normalDistribution/normalDistributionDefaults',[], function () {
    var dropDefaults = {
        data: {
            size: {
                x: 400,
                y: 300,
            },

            chosenValueDataType: "unlabeled", // "unlabeled", "labeled"
            methodType: "meanAndSTD", // "meanAndSTD", "numericDataset"
            numericIsPopulation: true,
            enableZoom: true,

            showLegend: true,
            showChosenLegend: false,
            showLowestLegend: true,
            showLowerLegend: true,
            showAverageLegend: true,
            showHigherLegend: true,
            showHighestLegend: true,
            legendPosition: "bottom",

            showTooltip: true,
            maxTooltips: 5,

            showChosenBars: true,
            barWidth: 5,
            valueRadius: 5,

            chosenLabel: "Your Data",
            lowestLabel: "Very Low",
            lowerLabel: "Below Average",
            averageLabel: "Average",
            higherLabel: "Above Average",
            highestLabel: "Outstanding",

            chosenColor: "rgba(255,0,0,1)",
            lowestColor: "rgba(253,1,2,1)",
            lowerColor: "rgba(255,149,55,1)",
            averageColor: "rgba(252,255,60,1)",
            higherColor: "rgba(107,254,41,1)",
            highestColor: "rgba(52,49,255,1)",

            showXAxis: true,
            axisXLabel: "",
            axisXLabelPosition: "outer-center",
            axisXPrecision: 2,

            showYAxis: false,
            axisYLabel: "",
            axisYLabelPosition: "outer-middle",
            axisYPrecision: 2,
            axisXRemovePadding: false,
            axisXLimit: false,

            showGridX: false,
            showGridY: false,

            emptyText: "No data",
        },
    };
    return dropDefaults;
});

